import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Input, Label, Button } from "@windmill/react-ui";
import CompanyService from "../services/CompanyService";
import DriverService from "../services/DriverService";
import { useAlert } from "react-alert";
import Spinner from "../components/Spinner/Spinner";
import Documents from "../pages/Documents";
import { format as formatCPF, isValid as isValidCPF } from "../utils/cpf";
import { isValid as isValidMail } from "../utils/email";

const empresaService = new CompanyService();
const driverService = new DriverService();

export default function SubmitPage() {
  const { id } = useParams();
  const alert = useAlert();
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarsenha, setConfirmarSenha] = useState("");
  const [empresa, setEmpresa] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [isRegistered, setIsRegistered] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const [touchedFields, setTouchedFields] = useState({
    nome: false,
    cpf: false,
    email: false,
    senha: false,
    confirmarsenha: false,
  });

  useEffect(() => {
    const fetchEmpresa = async () => {
      setLoading(true);
      try {
        const empresaFetch = await empresaService.getEmpresaById(id);
        setEmpresa(empresaFetch.data);
        localStorage.setItem("companyId", empresaFetch.data.id);
      } catch (error) {
        alert.error("Erro ao carregar empresa.");
      }
      setLoading(false);
    };

    fetchEmpresa();
  }, [id, alert]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Lógica de submissão
  };

  const handleBlur = (field) => {
    setTouchedFields({ ...touchedFields, [field]: true });
  };

  const handleNextStep = () => {
    if (currentStep === 1) {
      // Verifique se todos os campos da primeira etapa são válidos
      if (
        nome.length > 3 &&
        isValidCPF(cpf) &&
        isValidMail(email) &&
        senha.length > 5 &&
        confirmarsenha === senha
      ) {
        setCurrentStep(2);
      } else {
        alert.error("Por favor, preencha todos os campos corretamente.");
      }
    }
  };

  const handlePreviousStep = () => {
    if (currentStep === 2) {
      setCurrentStep(1);
    }
  };

  const handleVerifyUser = async () => {
    setIsVerifying(true);
    try {
      const response = await driverService.verifyDriver(cpf, email);
      if (response.data.cadastrado) {
        setIsVerified(true);
        alert.success("Usuário verificado com sucesso!");
      } else {
        alert.error("CPF ou email incorretos.");
      }
    } catch (error) {
      alert.error("Erro ao verificar usuário.");
    }
    setIsVerifying(false);
  };

  const handleLogin = async () => {
    setIsLoggingIn(true);
    try {
      const response = await driverService.loginDriver(email, cpf, senha);
      if (response.access_token) {
        setIsLoggedIn(true);
        alert.success("Login realizado com sucesso!");
      } else {
        alert.error("Senha incorreta.");
      }
    } catch (error) {
      alert.error("Erro ao realizar login.");
    }
    setIsLoggingIn(false);
  };

  return (
    <>
      {loading ? (
        <div className="flex-grow min-h-screen flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className="container mx-auto p-4">
          <h1 className="text-2xl font-semibold mb-4">
            Olá Motorista, a empresa {empresa.nome} deseja que você se cadastre!
          </h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            {!isRegistered && (
              <div className="flex justify-end">
                <Button type="button" onClick={() => setIsRegistered(true)}>
                  Já sou cadastrado na plataforma
                </Button>
              </div>
            )}
            {isRegistered && !isLoggedIn && (
              <>
                <div>
                  <Label htmlFor="cpf">
                    <span>CPF</span>
                    <Input
                      id="cpf"
                      type="text"
                      value={cpf}
                      placeholder="123.456.789-00"
                      onChange={(e) => setCpf(formatCPF(e.target.value))}
                      onBlur={() => handleBlur("cpf")}
                      valid={touchedFields.cpf ? isValidCPF(cpf) : undefined}
                      maxLength="14"
                      required
                      disabled={isVerified}
                    />
                  </Label>
                </div>
                <div>
                  <Label htmlFor="email">
                    <span>Email</span>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      placeholder="joao@gmail.com"
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={() => handleBlur("email")}
                      valid={
                        touchedFields.email ? isValidMail(email) : undefined
                      }
                      maxLength="50"
                      required
                      disabled={isVerified}
                    />
                  </Label>
                </div>
                {isVerified && (
                  <div>
                    <Label htmlFor="senha">
                      <span>Senha</span>
                      <Input
                        id="senha"
                        type="password"
                        placeholder="********"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        onBlur={() => handleBlur("senha")}
                        valid={
                          touchedFields.senha ? senha.length > 5 : undefined
                        }
                        maxLength="15"
                        required
                      />
                    </Label>
                  </div>
                )}
                <div className="flex justify-between">
                  <Button type="button" onClick={() => setIsRegistered(false)}>
                    Voltar
                  </Button>
                  <Button
                    type="button"
                    onClick={handleVerifyUser}
                    disabled={isVerified || isVerifying || !isValidMail(email)}
                  >
                    {isVerifying ? <Spinner size="small" /> : "Verificar"}
                  </Button>
                  {isVerified && (
                    <Button
                      type="button"
                      onClick={handleLogin}
                      disabled={isLoggingIn}
                    >
                      {isLoggingIn ? <Spinner size="small" /> : "Login"}
                    </Button>
                  )}
                </div>
              </>
            )}
            {isRegistered && isVerified && isLoggedIn && (
              <>
                <Documents />
              </>
            )}
            {!isRegistered && currentStep === 1 && (
              <>
                <div>
                  <Label htmlFor="nome">
                    <span>Nome</span>
                    <Input
                      id="nome"
                      type="text"
                      value={nome}
                      placeholder="João José"
                      onChange={(e) => setNome(e.target.value)}
                      onBlur={() => handleBlur("nome")}
                      valid={touchedFields.nome ? nome.length > 3 : undefined}
                      maxLength="50"
                      required
                    />
                  </Label>
                </div>
                <div>
                  <Label htmlFor="cpf">
                    <span>CPF</span>
                    <Input
                      id="cpf"
                      type="text"
                      value={cpf}
                      placeholder="123.456.789-00"
                      onChange={(e) => setCpf(formatCPF(e.target.value))}
                      onBlur={() => handleBlur("cpf")}
                      valid={touchedFields.cpf ? isValidCPF(cpf) : undefined}
                      maxLength="14"
                      required
                    />
                  </Label>
                </div>
                <div>
                  <Label htmlFor="email">
                    <span>Email</span>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      placeholder="joao@gmail.com"
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={() => handleBlur("email")}
                      valid={
                        touchedFields.email ? isValidMail(email) : undefined
                      }
                      maxLength="50"
                      required
                    />
                  </Label>
                </div>
                <div>
                  <Label htmlFor="senha">
                    <span>Senha</span>
                    <Input
                      id="senha"
                      type="password"
                      placeholder="********"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      onBlur={() => handleBlur("senha")}
                      valid={touchedFields.senha ? senha.length > 5 : undefined}
                      maxLength="15"
                      required
                    />
                  </Label>
                </div>
                <div>
                  <Label htmlFor="confirmarSenha">
                    <span>Confirmar Senha</span>
                    <Input
                      id="confirmarSenha"
                      type="password"
                      placeholder="********"
                      value={confirmarsenha}
                      onChange={(e) => setConfirmarSenha(e.target.value)}
                      onBlur={() => handleBlur("confirmarsenha")}
                      valid={
                        touchedFields.confirmarsenha
                          ? confirmarsenha === senha
                          : undefined
                      }
                      maxLength="15"
                      required
                    />
                  </Label>
                </div>
                <div className="flex justify-end">
                  <Button type="button" onClick={handleNextStep}>
                    Próximo
                  </Button>
                </div>
              </>
            )}
            {!isRegistered && currentStep === 2 && (
              <>
                <Documents />
                <Button type="button" onClick={handlePreviousStep}>
                  Voltar
                </Button>
                <Button type="submit">Submeter</Button>
              </>
            )}
          </form>
        </div>
      )}
    </>
  );
}
